// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Select,
  MenuItem,
} from "@mui/material";
import SoftBox from "../../components/common/softBox";
import DashboardNavbar from "../../components/navbars/dashboardNavbar";
import DashboardLayout from "../../components/layoutContainers/dashboardLayout";
import { Loader } from "../../components/common/loader";
import SoftTypography from "../../components/common/softTypography";
import SoftBadge from "../../components/common/softBadge";
import {
  IOrderItem,
  ISalesOrder,
} from "../../types/features/orderRequestsSlice";
import {
  getOrderRequestDetailData,
  getOrderRequestsData,
  postOrderToSap,
  updateOrderRequestDetailData,
} from "../../features/orderRequests";
import SoftButton from "../../components/common/softButton";
import SoftInput from "../../components/common/softInput";
import { prepareOrderData } from "../../utils/commonHelper";
import { toast } from "react-toastify";
import { useAppSelector } from "../../Hooks";
import {
  getSapOrderConfig,
  getSapPlantStorage,
} from "../../features/sapConfig";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const ViewOrderRequest = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { detail: detailData, orderRequestsLoader } = useSelector(
    (state: any) => state.orderRequests
  );
  const [detail, setDetail] = useState<ISalesOrder>({});
  const [salesOrg, setSalesOrg] = useState({
    value: "",
    label: "",
  });
  const { sapOrderConfigData, plantStorageData } = useAppSelector(
    (state: any) => state.sapConfig
  );
  const [selectedSalesOrg, setSelectedSalesOrg] = useState("");
  const [distChannel, setDistChannel] = useState("");
  const [selectedDistChannel, setSelectedDistChannel] = useState("");
  const [division, setDivision] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");

  useEffect(() => {
    if (detail?.BusPartner && detail?.CompanyCode) {
      dispatch(
        getSapOrderConfig({
          filter: `BusPartner eq '${detail.BusPartner}' and CompCode eq '${detail.CompanyCode}'`,
        })
      );
      dispatch(
        getSapPlantStorage({
          filter: `CompanyCode eq '${detail?.CompanyCode}'`,
        })
      );
    }
  }, [detail?.BusPartner, detail?.CompanyCode]);

  useEffect(() => {
    if (sapOrderConfigData && sapOrderConfigData.length > 0) {
      setSelectedSalesOrg(sapOrderConfigData[0].SalesOrg);

      const distChannelTemp = Array.from(
        new Set(
          sapOrderConfigData
            .filter((i) => i.SalesOrg === sapOrderConfigData[0].SalesOrg)
            .map((i) => i.DistChannel)
        )
      ).map((dc) => ({ value: dc, label: dc }));
      setSelectedDistChannel(distChannelTemp[0].value);
      setDistChannel(distChannelTemp);

      const divisionTemp = Array.from(
        new Set(
          sapOrderConfigData
            .filter(
              (i) =>
                i.SalesOrg === sapOrderConfigData[0].SalesOrg &&
                i.DistChannel === distChannelTemp[0].value
            )
            .map((i) => ({ value: i.Division, label: i.Division }))
        )
      );
      setSelectedDivision(divisionTemp[0].value);
      setDetail({
        ...detail,
        Division: divisionTemp[0].value,
        SalesOrg: distChannelTemp[0].value,
        DistChannel: distChannelTemp[0].value,
      });
      setDivision(divisionTemp);

      const uniqueSalesOrgs = Array.from(
        new Set(sapOrderConfigData.map((item) => item.SalesOrg))
      );
      const options = uniqueSalesOrgs.map((org) => ({
        value: org,
        label: org,
      }));
      setSalesOrg(options);
    }
  }, [sapOrderConfigData]);

  useEffect(() => {
    if (!selectedSalesOrg) return;

    const distChannelTemp = Array.from(
      new Set(
        sapOrderConfigData
          .filter((i) => i.SalesOrg === selectedSalesOrg)
          .map((i) => i.DistChannel)
      )
    ).map((dc) => ({ value: dc, label: dc }));

    setDistChannel(distChannelTemp);
  }, [selectedSalesOrg, sapOrderConfigData]);

  useEffect(() => {
    if (selectedDistChannel) {
      const divisionTemp = Array.from(
        new Set(
          sapOrderConfigData
            .filter(
              (i) =>
                i.SalesOrg === selectedSalesOrg &&
                i.DistChannel === selectedDistChannel
            )
            .map((i) => ({ value: i.Division, label: i.Division }))
        )
      );
      setDivision(divisionTemp);
    }
  }, [selectedDistChannel]);

  useEffect(() => {
    if (detailData) {
      setDetail(detailData);
    }
  }, [detailData]);

  useEffect(() => {
    if (id) {
      dispatch(getOrderRequestDetailData({ id }));
    }
  }, [dispatch, id]);

  const submitOrderToSap = (data) => {
    const finalData = prepareOrderData(data);
    dispatch(postOrderToSap({ data: finalData, id })).then((res) => {
      if (res && res.payload && res.payload.status) {
        dispatch(getOrderRequestsData({ page: 1, limit: 10 }));
        toast.success(res.payload.message);
      }
    });
  };

  if (orderRequestsLoader) {
    return <Loader />;
  }

  const handleReject = () => {
    setDetail({
      ...detail,
      status: "reject",
    });
    dispatch(
      updateOrderRequestDetailData({
        id: detail?._id,
        data: { status: "reject" },
      })
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox
        sx={{
          padding: "15px",
          backgroundColor: "#fff",
          boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
        }}
      >
        <SoftBox
          sx={{
            fontSize: "18px",
            fontWeight: "700",
            lineHeight: "normal",
            paddingBottom: "20px",
            marginBottom: "20px",
            borderRadius: "0px",
            borderBottom: "1px solid #ccc",
          }}
        >
          {`${detail?.user_id?.owner_name + "'s" || ""} Order Request`}
        </SoftBox>
        <SoftBox
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          pb={1}
        >
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              paddingBottom: "10px",
              marginBottom: "0px",
              borderBottom: "1px solid #ccc",
              borderRadius: "0px",
              width: {
                sm: "100%",
                md: "30%",
              },
            }}
          >
            <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Business Partner No: &nbsp;
            </SoftTypography>
            <SoftTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{detail?.BusPartner || "N/A"}
            </SoftTypography>
          </SoftBox>
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              paddingBottom: "10px",
              marginBottom: "0px",
              borderBottom: "1px solid #ccc",
              borderRadius: "0px",
              width: {
                sm: "100%",
                md: "30%",
              },
            }}
          >
            <SoftTypography
              variant="button"
              tag="h3"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Name: &nbsp;
            </SoftTypography>
            <SoftTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{detail?.user_id?.owner_name || "N/A"}
            </SoftTypography>
          </SoftBox>
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              paddingBottom: "10px",
              marginBottom: "0px",
              borderBottom: "1px solid #ccc",
              borderRadius: "0px",
              width: {
                sm: "100%",
                md: "30%",
              },
            }}
          >
            <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Status: &nbsp;
            </SoftTypography>
            <SoftBadge
              variant="gradient"
              badgeContent={detail?.status}
              color={
                detail?.status === "pending"
                  ? "info"
                  : detail?.status === "reject"
                  ? "error"
                  : "success"
              }
              size="xs"
              container
            />
          </SoftBox>
        </SoftBox>
        <SoftBox
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          pb={1}
        >
          <SoftBox
            sx={{
              width: {
                sm: "100%",
                md: "30%",
              },
            }}
          >
            <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Sale Organization: &nbsp;
            </SoftTypography>
            <Select
              id="demo-simple-select"
              name="SalesOrg"
              value={selectedSalesOrg}
              onChange={(e) => {
                setSelectedSalesOrg(e.target.value);
                setDetail({
                  ...detail,
                  SalesOrg: e.target.value,
                });
              }}
              IconComponent={KeyboardArrowDownIcon}
              fullWidth
              size="small"
              sx={{
                padding: "0px 8px !important",
                height: "40px !important",
                display: "block !important",
                ".MuiSelect-select": {
                  padding: "0px 8px !important",
                  height: "40px !important",
                },
                ".MuiSelect-nativeInput": {
                  height: "40px !important",
                },
                ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                  display: "block !important",
                  fontSize: "1.25rem !important",
                },
                ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                  display: "block !important",
                  fontSize: "1.25rem !important",
                },
              }}
            >
              {salesOrg &&
                salesOrg.length > 0 &&
                salesOrg.map((item: any) => {
                  return <MenuItem value={item.value}>{item.label}</MenuItem>;
                })}
            </Select>
          </SoftBox>
          <SoftBox
            sx={{
              width: {
                sm: "100%",
                md: "30%",
              },
            }}
          >
            <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Dist. Channel: &nbsp;
            </SoftTypography>
            <Select
              value={selectedDistChannel}
              onChange={(e) => {
                setSelectedDistChannel(e.target.value);
                setDetail({
                  ...detail,
                  DistChannel: e.target.value,
                });
              }}
              id="demo-simple-select"
              name="distChannel"
              IconComponent={KeyboardArrowDownIcon}
              fullWidth
              size="small"
              sx={{
                padding: "0px 8px !important",
                height: "40px !important",
                display: "block !important",
                ".MuiSelect-select": {
                  padding: "0px 8px !important",
                  height: "40px !important",
                },
                ".MuiSelect-nativeInput": {
                  height: "40px !important",
                },
                ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                  display: "block !important",
                  fontSize: "1.25rem !important",
                },
                ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                  display: "block !important",
                  fontSize: "1.25rem !important",
                },
              }}
            >
              {distChannel &&
                distChannel.map((item: any, index: number) => (
                  <MenuItem value={item.value}>{item.label}</MenuItem>
                ))}
            </Select>
          </SoftBox>
          <SoftBox
            sx={{
              width: {
                sm: "100%",
                md: "30%",
              },
            }}
          >
            <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Division: &nbsp;
            </SoftTypography>
            <Select
              value={selectedDivision}
              onChange={(e) => {
                setSelectedDivision(e.target.value);
                setDetail({
                  ...detail,
                  Division: e.target.value,
                });
              }}
              id="demo-simple-select"
              name="division"
              IconComponent={KeyboardArrowDownIcon}
                    fullWidth
                    size="small"
                    sx={{
                      padding: "0px 8px !important",
                      height: "40px !important",
                      display: "block !important",
                      ".MuiSelect-select": {
                        padding: "0px 8px !important",
                        height: "40px !important",
                      },
                      ".MuiSelect-nativeInput": {
                        height: "40px !important",
                      },
                      ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                      ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                    }}
            >
              {division &&
                division.map((item: any, index: number) => (
                  <MenuItem value={item.value}>{item.label}</MenuItem>
                ))}
            </Select>
          </SoftBox>
        </SoftBox>
        <SoftBox
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          pb={1}
        >
          <SoftBox
            sx={{
              width: {
                sm: "100%",
                md: "30%",
              },
            }}
          >
            <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Order Type: &nbsp;
            </SoftTypography>
            <SoftTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{detail?.OrderType || "N/A"}
            </SoftTypography>
          </SoftBox>
        </SoftBox>

        <SoftBox>
          <SoftTypography
            variant="button"
            fontWeight="bold"
            textTransform="capitalize"
            pb={1}
          >
            Material Details: &nbsp;
          </SoftTypography>
          <SoftBox pb={2}>
            <TableContainer
              className="table-container"
              sx={{ padding: "0px", borderRadius: "0px" }}
            >
              <Table
                sx={{ Width: "100%" }}
                className="w3-table-all"
                aria-label="Order Material List table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell>Item Number</TableCell>
                    <TableCell>Material No</TableCell>
                    <TableCell>Plant No</TableCell>
                    <TableCell>Target Quantity</TableCell>
                    <TableCell>Store Location</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {detail?.NavHeaderToItem &&
                    detail?.NavHeaderToItem?.length > 0 &&
                    detail?.NavHeaderToItem.map(
                      (item: IOrderItem, index: number) => {
                        // All available plants
                        const availablePlants =
                          plantStorageData && plantStorageData.length > 0
                            ? Array.from(
                                new Set(
                                  plantStorageData.map((ps: any) => ps.Plant)
                                )
                              ).map((p) => ({ value: p, label: p }))
                            : [];

                        // StoreLocs for this row's plant
                        const availableStorLocs =
                          plantStorageData && plantStorageData.length > 0
                            ? Array.from(
                                new Set(
                                  plantStorageData
                                    .filter(
                                      (ps: any) => ps.Plant === item.Plant
                                    )
                                    .map((ps: any) => ps.StorLoc)
                                )
                              ).map((sl) => ({ value: sl, label: sl }))
                            : [];

                        return (
                          <TableRow key={"order-item-" + index}>
                            <TableCell>{item.ItmNumber}</TableCell>
                            <TableCell>{item.Material}</TableCell>
                            <TableCell>
                              <Select
                                value={item.Plant || ""}
                                onChange={(e) => {
                                  const newPlant = e.target.value;
                                  // Find first storLoc for new plant
                                  const storLocsForPlant = plantStorageData
                                    ? plantStorageData
                                        .filter(
                                          (ps: any) => ps.Plant === newPlant
                                        )
                                        .map((ps: any) => ps.StorLoc)
                                    : [];
                                  const firstStorLoc =
                                    storLocsForPlant[0] || "";

                                  setDetail({
                                    ...detail,
                                    NavHeaderToItem: detail.NavHeaderToItem.map(
                                      (itm: any, i: number) =>
                                        i === index
                                          ? {
                                              ...itm,
                                              Plant: newPlant,
                                              StoreLoc: firstStorLoc, // reset store loc on plant change
                                            }
                                          : itm
                                    ),
                                  });
                                }}
                                id="plant-select"
                                name="Plant"
                                style={{ width: "100%" }}
                              >
                                {availablePlants.map((p) => (
                                  <MenuItem key={p.value} value={p.value}>
                                    {p.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </TableCell>
                            <TableCell>
                              <SoftInput
                                value={item.TargetQty}
                                onChange={(e) =>
                                  setDetail({
                                    ...detail,
                                    NavHeaderToItem: detail.NavHeaderToItem.map(
                                      (itm: any, i: number) =>
                                        i === index
                                          ? {
                                              ...itm,
                                              TargetQty: e.target.value,
                                            }
                                          : itm
                                    ),
                                  })
                                }
                              />
                            </TableCell>
                            <TableCell align="right">
                              <Select
                                value={item.StoreLoc || ""}
                                onChange={(e) => {
                                  setDetail({
                                    ...detail,
                                    NavHeaderToItem: detail.NavHeaderToItem.map(
                                      (itm: any, i: number) =>
                                        i === index
                                          ? { ...itm, StoreLoc: e.target.value }
                                          : itm
                                    ),
                                  });
                                }}
                                id="storloc-select"
                                name="storLoc"
                                style={{ width: "100%" }}
                              >
                                {availableStorLocs.map((sl) => (
                                  <MenuItem key={sl.value} value={sl.value}>
                                    {sl.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </TableCell>
                          </TableRow>
                        );
                      }
                    )}
                </TableBody>
              </Table>
            </TableContainer>
          </SoftBox>
        </SoftBox>
        <SoftBox pb={2}>
          {detail?.SalesOrder && (
            <p style={{ fontSize: 16, marginRight: "14px" }}>
              Your Order is Submited to Sap. Sales Order No:{" "}
              {detail?.SalesOrder}
            </p>
          )}
        </SoftBox>
        <SoftBox display="flex" alignContent={"center"} justifyContent={"end"}>
          <SoftButton
            disabled={detail?.status !== "pending"}
            onClick={() => handleReject()}
            className="modal_cancel modal_btn"
          >
            Reject
          </SoftButton>
          <SoftButton
            className="modal_btn"
            disabled={detail?.SalesOrder || detail?.status !== "pending"}
            onClick={() => submitOrderToSap(detail)}
          >
            Send To SAP
          </SoftButton>
        </SoftBox>
      </SoftBox>
    </DashboardLayout>
  );
};

export default ViewOrderRequest;
